import axios from 'axios'
import setConfig from '@/config/axios-config'
import common from '@/util/common'
setConfig(axios)

// const basePath = '/MarkServer/json/mark'
const basePath = 'PJServer/action'
const pjUnitPath = 'PJService/action/pjunit'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

/**
 * 修正成绩(仅学校流程的考试, 学校信息管理员)
 * @author wangk 2018-11-01T17:37:09+0800
 * @param  {Object} params { examId: '123' }
 * @return {[type]}        [description]
 */
const fixScore = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/unrelease/unrelease.jsp`, `app=unreleaseResource&flag=unrelease&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 查询文件引擎
 * @author wangk 2018-11-20T16:23:48+0800
 * @param  {Object} params {"examId":"1542619130226","subjectId":"1525835962893"}
 * @return {[type]}        [description]
 */
const assignFileEngine = (params = {}) => {
  let urlParams = 'app=assignFileEngine&flag=assignFileEngine&json=' + JSON.stringify(params)
  return axios.post(`${basePath}/assignFileEngine.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}

/**
 * 申请评卷资源
 * @author changh 2018-11-20T16:23:48+0800
 * @param  {Object} params {"examId":"1542619130226","subjectId":"1525835962893"}
 * @return {[type]}        [description]
 */
const assignPJVM = (params = {}) => {
  let urlParams = 'app=assignPJVM&json=' + JSON.stringify(params)
  return axios.post(`${basePath}/assignPJVM.jsp`, urlParams, axiosConfig)
    .then(res => res.data)
}
/**
 * @name 导入OMR成绩,来源扫描服务提供的接口
 * @param1 {json} {examId:"", subjectId:"", forceExamUintUrl: true}
 *                 forceExamUintUrl 仅仅用在只有客观题时
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const importOmrScan = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139'
  return axios.post(`${unitUrl}/importOmrScan.jsp`, urlParams, axiosConfig).then(res => res.data)
}

/**
 * @name OMR成绩统分接口
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const statOmrScore = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  return axios.post(`${unitUrl}/statOmrScore.jsp`, urlParams, axiosConfig).then(res => res.data)
}
/**
 * @name 获取OMR成绩统分当前状态接口
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const getStatOmrScoreFlag = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  return axios.get(`${unitUrl}/getStatOmrScoreFlag.jsp`, urlParams, axiosConfig).then(res => res.data)
}

/**
 * @name 获取OMR成绩统分日志接口
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const getStatOmrScoreProgress = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  return axios.get(`${unitUrl}/getStatOmrScoreProgress.jsp`, urlParams, axiosConfig).then(res => res.data)
}
/**
 * @name 重置OMR成绩统分当前状态接口
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const clearstatOmrScoreFlag = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  return axios.get(`${unitUrl}/clearStatOmrScoreFlag.jsp`, urlParams, axiosConfig).then(res => res.data)
}
/**
 * @name OMR成绩统分接口
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const resultCombine = (params = {}) => {
  let urlParams = 'app=resultCombine&json=' + JSON.stringify(params)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  return axios.post(`${unitUrl}/resultCombine.jsp`, urlParams, axiosConfig).then(res => res.data)
}

/**
 * @name 成绩合成进度查询
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const resultCombineProcess = (params = {}) => {
  let urlParams = 'app=resultCombineProcess&flag=' + params.flag + '&json=' + JSON.stringify({})
  let unitUrl = params.query.split('?')[0]
  unitUrl = unitUrl.substr(unitUrl.indexOf('PJService'), unitUrl.length - 1)
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/resultCombineProcess.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res)
}
/**
 * @name 获取评卷单元地址
 * @param1 {json} {examId:"", subjectId:""} forceExamUintUrl 仅仅用在只有客观题时
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const getPjUnitUrl = (params = {}) => {
  let queryExamUnitParam = { examId: params.examId, subjectId: params.subjectId }
  if (params.forceExamUintUrl) {
    queryExamUnitParam.forceExamUintUrl = params.forceExamUintUrl
  }
  return axios.post(`${basePath}/queryUnit2.jsp`, 'app=queryUnit&flag=queryUnit&json=' + JSON.stringify(queryExamUnitParam), axiosConfig)
    .then(res => res)
}

/**
 * @name 成绩检查项查询
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const queryExamResult = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId}
  if (params.flag === 'ZgHighAndKgLowCount' || params.flag === 'KgHighAndZgLowCount') {
    param.zgTotalScore = params.zgTotalScore
    param.kgTotalScore = params.kgTotalScore
  }
  if (params.flag === 'queryMaxScoreStudents') {
    param.zgTotalScore = params.zgTotalScore
    param.kgTotalScore = params.kgTotalScore
    param.maxType = params.maxType
  }
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let urlParams = 'flag=' + params.flag + '&json=' + JSON.stringify(param)
  let unitUrl = pjUnitUrl + '/queryExamResult.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * @name 成绩检查项查询
 * @param1 {json} {examId:"", subjectId:""}
 * @param2 {function} [callBack] 回调函数
 * @return {JSON} {result: true, count: 13}
 */
const queryPjItem = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId}
  let urlParams = 'json=' + JSON.stringify(param)
  let unitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId) + '/queryItem.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 查询本评卷单元的评卷状态
 * 调用后台接口:statusChange.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 *    data:[{"status":"regular","divId":"1"}]
 *    regular:表示正评
 *    tryout:试评
 *    preparing:数据准备中
 *    standby:准备完成
*/
const queryPjStatus = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/statusChange.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 查询本评卷单元的评卷进度,首页评卷进度用
 * 调用后台接口:queryStatus.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 *    data:[{avgscore1: "4.19",
            avgscore2: "4.19",
            charge: "",
            confcnt: "0",
            divId: "100",
            done: "8",
            probcnt: "0",
            qty1: "0",
            qty2: "0",
            schoolId: "",
            total: "8",
            undocon: "0",
            undopro: "0"}]
*/
const queryPjProgress = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId}
  let urlParams = 'json=' + JSON.stringify(param)
  if (params.schoolId) {
    urlParams += '&schoolId=' + params.schoolId
  }
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryStatus.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 修改本评卷单元的评卷状态  重评
 * 调用后台接口:reJudge.jsp
 * @author chenxb 2020-06-04T16:23:48+0800
 * @param  {Object} params {"examId":"1585712336461","subjectId":"1571125069818","divId":"100"}
 * @return {[type]}        [description]
 */
const rePjStatus = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId, divId: params.divId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/reJudge.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 修改本评卷单元的评卷状态
 * 调用后台接口:statusChange.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796", status: "regular", "divId": ["100"]}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 *    data:[{"status":"regular","divId":"1"}]
 *    regular:表示正评
 *    tryout:试评
 *    preparing:数据准备中
 *    standby:准备完成
*/
const changePjStatus = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId, status: params.status, divId: params.divId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/statusChange.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 触发后台 创建评卷任务
 * @param {*} params {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false"}
 */
const createPjTask = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/createPjTask.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 获取评卷任务
 * 调用后台接口:TaskRequest.jsp/TaskRequest_Tryout.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const queryTask = (params = {}) => {
  let param = {teacher: params.userId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskRequest.jsp'
  if (params.pjStatus === 'tryout') {
    unitUrl = pjUnitUrl + '/TaskRequest_Tryout.jsp'
  }
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 获取评卷任务
 * 调用后台接口:queryTask
 * @param {Object} param {"data":{"startDate":"","endDate":"","startScore":"","endScore":"","teacherInfo":"","orgId":"1571125955196","userId":"1571295460383","examId":"1573629980157","subjectId":"1571295424552","divId":"200","encode":"","finalPaper":false,"popPaper":false,"normalPaper":true},"pageNum":1,"pageSize":12}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const queryTaskList = (params = {}) => {
  return axios.post(`${pjUnitPath}/queryTask`, params).then(res => res.data)
}
/**
 * 提交给分
 * 调用后台接口:TaskRequest.jsp/TaskRequest_Tryout.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const submitScore = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params.data)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskResponse.jsp'
  if (params.pjStatus === 'tryout') {
    unitUrl = pjUnitUrl + '/TaskResponse_Tryout.jsp'
  }
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 回评给分
 * 调用后台接口:TaskResponse_Redo.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const submitRescore = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params.data)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskResponse_Redo.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 抽查给分
 * 调用后台接口:TaskResponse_Arbitration.jsp
 * @param {Object} param {"taskResponse":{"no":"332298","taskNo":"","taskId":"ajwejtqtah","divId":"200","encode":"ajwejtqtah","score":[[1],[1]],"scoreDetail":[[1]],"teacher":"1571295460383","question":[],"pjSeq":"1003","logTime":"2019-11-22 16:49:35","desc":""},"taskRequest":{"taskNo":"","taskId":"ajwejtqtah","logTime":"2019-11-22 16:49:35","teacher":"1571295460383"}}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const submitCheckScore = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params.data)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskResponse_Arbitration.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 提交特殊卷分数 如问题卷1002，仲裁卷1001
 * 调用后台接口:TaskResponse_group.jsp
 * @param {Object} param {"examId":"1572331475968","subjectId":"1571125089016","divId":"100"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const submitSpecialScore = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params.param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskResponse_group.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 获取评卷图像
 * 调用后台接口:getImagePath.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const getImagePath = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId, divId: params.itemId, encodeIds: [params.encode]}
  let urlParams = 'app=getZT&flag=get&json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/getImagePath.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 获取评卷全图
 * 调用后台接口:getImagePath.jsp
 * @param {Object} param {examId:_pageInfo.examId, subjectId:_pageInfo.subjectId, encodeIds:[_pageInfo.encode]}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
*/
const getFullImagePath = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId, encodeIds: [params.encode]}
  let urlParams = 'app=getZT&flag=wholeSheet&json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/getImagePath.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 获取评卷总任务
 * 调用后台接口:TaskRequest.jsp/TaskRequest_Tryout.jsp
 * @param {Object} param {"examId":"1407209010500","subjectId":"1407209002796",divId:""}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} { "total": "663.0", "done": "82.0", "question": "3.0", "arbitration": "0.0"}
*/
const queryProcess = (params = {}) => {
  let param = {examId: params.examId, subjectId: params.subjectId, divId: params.itemId}
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryProcess.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 获取评卷教师进度
 * 调用后台接口:queryTeacherProcess.jsp
 * @param {Object} param {"examId":"1571129698363","subjectId":"1571125966948","divId":"100","teacherId":["1571126166003"],"groupId":"1571125955196"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const queryTeacherProcess = (params = {}) => {
  let param = {examId: params.examId,
    subjectId: params.subjectId,
    divId: params.itemId,
    teacherId: [params.teacherId],
    groupId: params.groupId}
  let urlParams = 'json=' + JSON.stringify(param) + '&groupId=' + param.groupId
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryTeacherProcess.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 获取回评数据
 * 调用后台接口:queryPageTaskResponseList
 * @param {Object} param {"teacher":"1571129698363","unitUrl":""}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const queryTaskResponseList = (params = {}) => {
  return axios.post(`${pjUnitPath}/queryPageTaskResponseList`, params).then(res => {
    console.log(res)
    return res.data
  })
}

/**
 * 回收评卷任务
 * 调用后台接口:queryTeacherProcess.jsp
 * @param {Object} param { examId: urlParam.examId,subjectId: urlParam.subjectId,divId: [urlParam.divId],teacher: urlParam.userId}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const taskRelease = (params = {}) => {
  let urlParams = 'json=' + JSON.stringify(params)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.divId[0])
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskRelease.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 保存批注信息
 * 调用后台接口:saveTraces
 * @param {Object} param {
  "data":{
   "examId":"1560221825464",
   "subjectId":"15555768070341",
   "divId":"100",
   "encode":"3cn6xmilaiwi",
    "pjSeq":"1",
    "teacherId":"1555576745188",
    "traces":[{
      "traceType": "1",
     "data": "{accdddddddddddddddddddd}"
    }]
  }
}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const saveTraces = (param = {}) => {
  return axios.post(`${pjUnitPath}/saveTraces`, param).then(res => res.data)
}

/**
 * 查询批注信息
 * 调用后台接口:getTraces
 * @param {Object} param {
  "data":{
   "examId":"1560221825464",
   "subjectId":"1555576807034",
   "divId":"100",
   "encodes":["3cn6xmilaiwi"],
   "teacherId":"1555576745188"
  }
}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const getTraces = (param = {}) => {
  return axios.post(`${pjUnitPath}/getTraces`, param).then(res => res.data)
}

/**
 * 获取特殊卷数据列表 1001 仲裁卷 1002 问题卷
 * 调用后台接口:TaskRequest_group.jsp
 * @param {Object} param {"groupId":"1571125247817","pjSeq":"1002"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const getSpecialTask = (params = {}) => {
  let param = params.param
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/TaskRequest_group.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 查询评卷的详细日志，只包括3评、问题卷、仲裁卷日志。
 * 调用后台接口:queryLogEvent.jsp
 * @param {Object} param {"groupId":"1571125247817","pjSeq":"1002"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const getReadLog = (params = {}) => {
  let param = params.param
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryLogEvent.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 查询当前题目评卷教师信息。
 * 调用后台接口:queryTeacher.jsp
 * @param {Object} param {"examId":"1572331475968","subjectId":"1571125089016","divId":"100"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const queryTeacher = (params = {}) => {
  let param = params.param
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryTeacher.jsp'
  // let unitUrl = 'PJService/action/pjexam/1569293141049/1557971622139/queryExamResult.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 查询评卷给分信息明细。
 * 调用后台接口:queryLogResponse.jsp
 * @param {Object} param {"examId":"1572944503298","subjectId":"1571295432983","taskId":["cuiwuura91","cc343qlw69e"]}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const queryLogResponse = (params = {}) => {
  let param = params.param
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(params.examId, params.subjectId, params.itemId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryLogResponse.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
   * 取消发布
   * @Author   lyc
   * @DateTime  20191216
   * @param    {Object}   param    {examId: ""}
   * @param    {Function} callback [description]
   * @return   {[type]}            [description]
   */
const unrelease = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/unrelease/unrelease.jsp`, `app=unreleaseResource&flag=unrelease&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
   * 获取全卷查看密保坐标
   * @Author   changh
   * @DateTime  20191216
   * @param    {Object}   param    {examId: ""}
   * @param    {Function} callback [description]
   * @return   {[type]}            [description]
   */
const getSecretPositon = () => {
  return axios.get('/secret-postion.json').then(res => res.data)
}

/**
 * @name 同步主观题给分点别名，不重评
 * @param  {
  examId: _urlParam.examId,
  subjectId: _urlParam.subjectId,
  divId: divId
}
* @return {JSON} {result: true, count: 13}
*/
const freshItem = (param = {}) => {
  let urlParams = 'json=' + JSON.stringify(param)
  let pjUnitUrl = common.createPJUnitUrl(param.examId, param.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/freshItem.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * 注册评卷，升级评卷版本
 * @Author   changh
 * @DateTime  20191216
 * @param    {Object}   param     {examId:"", subjectId:"", force: true}
 * @return   {[type]}            [description]
 */
const AssignPJVirtualMachine = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/assignPJVM.jsp`, `app=unreleaseResource&flag=unrelease&json=${json}`, axiosConfig)
    .then(res => res.data)
}

/**
 * 获取重评恢复版本信息
 * @Author   chenxb
 * @DateTime  2020917
 * @param    {Object}   param     json: {"url":"http://10.117.1.248/PJService/action/pjunit/1593331736687/1571125908425/26"}
 * @return   {[type]}            [description]
 */
const QueryVersions = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${params.url}/versions`, `json=${json}`, axiosConfig)
    .then(res => res.data)
}
/**
 * 重评恢复
 * @Author   chenxb
 * @DateTime  2020917
 * @param    {Object}   param     {url: "http://192.168.1.235/PJService/action/pjunit/1469109457174/1467595181643/71", versionId: "011469124897218863"}
 * @return   {[type]}            [description]
 */
const RestoreDiv = (params = {}) => {
  return axios.post(`${params.url}/restore?versionId=${params.versionId}`, {versionId: params.versionId}, axiosConfig)
    .then(res => res.data)
}

/**
 * @name 修复评卷监控
 * @param  {
  examId: _urlParam.examId,
  subjectId: _urlParam.subjectId,
}
 * @return bool
 */
const RepairPjMonitor = (param = {}) => {
  let urlParams = 'json='
  let pjUnitUrl = common.createPJUnitUrl(param.examId, param.subjectId)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/repairPjMonitor.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

/**
 * @name 图像查看，查询评分轨迹
 * @param  {
  examId: _urlParam.examId,
  subjectId: _urlParam.subjectId,
}
 * @return bool
 */
const queryCandidateLogResponse = (param = {}) => {
  let urlParams = 'json='
  let pjUnitUrl = common.createPJUnitUrl(param.examId, param.subjectId, param.studentCode)
  pjUnitUrl = pjUnitUrl.substr(pjUnitUrl.indexOf('PJService'), pjUnitUrl.length - 1)
  let unitUrl = pjUnitUrl + '/queryCandidateLogResponse.jsp'
  return axios.post(unitUrl, urlParams, axiosConfig).then(res => res.data)
}

export {
  fixScore,
  assignFileEngine,
  assignPJVM,
  importOmrScan,
  statOmrScore,
  getStatOmrScoreFlag,
  getStatOmrScoreProgress,
  clearstatOmrScoreFlag,
  resultCombine,
  resultCombineProcess,
  getPjUnitUrl,
  queryExamResult,
  queryPjItem,
  queryPjStatus,
  queryPjProgress,
  queryTask,
  queryTaskList,
  submitScore,
  submitRescore,
  submitCheckScore,
  getImagePath,
  getFullImagePath,
  queryProcess,
  queryTeacherProcess,
  queryTaskResponseList,
  taskRelease,
  getTraces,
  saveTraces,
  getSpecialTask,
  getReadLog,
  queryTeacher,
  queryLogResponse,
  submitSpecialScore,
  unrelease,
  changePjStatus,
  rePjStatus,
  createPjTask,
  getSecretPositon,
  freshItem,
  AssignPJVirtualMachine,
  QueryVersions,
  RestoreDiv,
  RepairPjMonitor,
  queryCandidateLogResponse
}



// WEBPACK FOOTER //
// ./src/model/pj-server-model.js